import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { DashboardManagerRequestResponse } from "../../../../../business";

export const DashboardManagerContent: React.FC<DashboardManagerRequestResponse> = ({ response }) => {
    return (
        <>
            <h4 className="mb-4">Dashboard</h4>
            <Row>
                <Col sm={12} md={3} className="mb-3">
                    <Card
                        bg="primary"
                        key={'member'}
                        text={'white'}
                        border="none"
                    >
                        <Card.Body className="text-left">
                            <small>Assinaturas em aberto</small>
                            <Row>
                                <Col style={{ fontSize: '24px' }} >
                                    {response.invoicesWaiting}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={12} md={3} className="mb-3">
                    <Card
                        bg="primary"
                        key={'published'}
                        text={'white'}
                        border="none"
                        className="bg-theme-secondary"
                    >
                        <Card.Body className="text-left">
                            <small>Boletos em vencimento</small>
                            <Row>
                                <Col style={{ fontSize: '24px' }} >
                                    {response.invoicesExpiring}
                                </Col>
                            </Row>
                            <span style={{ fontSize: 11 }}>
                                Expira em <strong>3 dias</strong>
                            </span>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={12} md={3} className="mb-3">
                    <Card
                        bg="success"
                        key={'subscription'}
                        text={'white'}
                        border="none"
                    >
                        <Card.Body className="text-left">
                            <small>Boletos vencidos</small>
                            <Row>
                                <Col style={{ fontSize: '24px' }} >
                                    {response.invoicesExpired}
                                </Col>
                            </Row>
                            <span style={{ fontSize: 11 }}>
                                Venceram há pelo menos <strong>24 horas</strong>
                            </span>
                        </Card.Body>
                    </Card>
                </Col>
            </Row >
        </>
    )
}